<template>
  <transition name="spmodal" appear>
    <div class="spmodal spmodal-overlay">
      <div class="spmodal-window">
        <div class="spmodal-header">
          <div class="spmodal-search">
            <div class="search">
              <SearchButton imgSrc="search-white@2x.png" />
            </div>
            <input class="input-search" type="text" placeholder="検索キーワード" />
          </div>
          <div class="JP"><router-link to="/">JP</router-link></div>
          <div class="CN"><a href="http://cn.jpestateone.com/">CN</a></div>
        </div>
        <div class="spmodal-content" @click="$emit('close')">
          <div class="sp-header-menu">
            <div class="sp-nav">
              <router-link to="/">TOP</router-link>
              <router-link to="/company">COMPANY</router-link>
              <router-link to="/team">TEAM</router-link>
              <router-link to="/gallery">GALLERY</router-link>
              <!-- <router-link to="/news_list">NEWS</router-link> -->
              <router-link to="/recruit">RECRUITMENT</router-link>
              <router-link to="/contact">CONTACT</router-link>
            </div>
          </div>
          <div class="sp-office">
            Tokyo office
          </div>
          <div class="sp-contact">
            03-5826-4777
            <br>wang@jpestateone.com
          </div>
          <img src="@/assets/estate_icon/pc/logo_gray@2.png"/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import SearchButton from '@/components/SearchButton.vue'
export default {
  name: 'SpModal',
  components: {
    SearchButton
  },
  created () {
    window.addEventListener('touchmove',
      event.preventDefault)
  },
  destroyed () {
    window.removeEventListener('touchmove',
      event.preventDefault)
  }
}
</script>

<style lang="scss" scoped>
.spmodal {
  &.spmodal-overlay {
    display: block;
    position: fixed;
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0,0,0);
    z-index: 40;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  &-window {
    background: #fff;
    border-radius: 4px;
    overflow: auto;
    width: 100vw;
    height: 100vh;
  }

  &-content {
    overflow: auto;
    padding-left: 45px;
    padding-top: 75px;

    .sp-header-menu{
      .sp-nav{
        a, a:visited{
          display: block;
          text-decoration: none;
          color: #3B3B3B;
          font-size: 20px;
          width: 150px;
          font-weight: bolder;
          padding: 7px;

          &.router-link-exact-active {
            color: #D0AF1F;
          }
        }
      }
    }

    .sp-office{
      font-size: 10px;
      font-weight: bolder;
      color: #737B7B;
      margin-top: 30px;
      padding: 9px;
      padding-bottom: 2px;
    }
    .sp-contact{
      font-size: 10px;
      font-weight: bolder;
      color: #3B3B3B;
      margin-bottom: 30px;
      padding: 9px;
      padding-top: 2px;
    }
    img{
      width: 100px;
      height: auto;
      padding-left: 9px;
    }
  }

  &-header {
    background-color: #fff;
    height: 50px;
    display: flex;
    padding-top: .5vw;
    justify-content: flex-start;
    align-items: center;
    font-size: 16px;

    .JP{
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #737B7B;
      color: #F8F8F8;
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      text-decoration: none;
      width: 45px;
      height: 35px;
      a, a:visited{
        text-decoration: none;
        color: #F8F8F8;
      }
    }
    .CN{
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #3B3B3B;
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      margin-right: 90px;
      width: 45px;
      height: 35px;
      a, a:visited{
        text-decoration: none;
        color: #D0AF1F;
      }
    }
  }
  &-search{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 25px;
    font-family: sans-serif;
    font-weight: 400;
    margin-left: 18px;
    margin-right: 18px;
    width: 65%;
    background-color: #3B3B3B;
    border-radius: 71px;

    .search{
      display: flex;
      align-items: center;
      margin-left: 15px;
      margin-right: 15px;
      height: 20px;
    }
    .input-search{
      border: 0;
      background: rgba(0,0,0,0);
      width: 100%;
      height: 30px;
      font-size: 15px;
      color: #fff;
    }
  }
}

// オーバーレイのトランジション
.spmodal-enter-active, .spmodal-leave-active {
  transition: opacity 0.4s;

  // オーバーレイに包含されているモーダルウィンドウのトランジション
  .spmodal-window {
    transition: opacity 0.4s, transform 0.4s;
  }
}

// ディレイを付けるとモーダルウィンドウが消えた後にオーバーレイが消える
.spmodal-leave-active {
  transition: opacity 0.6s ease 0.4s;
}

.spmodal-enter, .spmodal-leave-to {
  opacity: 0;

  .spmodal-window {
    opacity: 0;
  }
}
</style>
